exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup .sweet-modal.is-alert .sweet-content{padding:0!important}.popup .sweet-modal.is-alert{width:420px!important}@media screen and (max-width:600px){.popup .sweet-modal.is-alert{width:320px!important}}", ""]);

// exports
